import "core-js/modules/es.array.concat.js";

/*
 * @Author       : Qoder AI
 * @Date         : 2026-05-27
 * @Description  : 底部双按钮组合组件（一元购 + 免费解锁）
 */
import './index.less';
import bus from '@/utils/eventemitter';
import { sensClickInitiative, sensElementView } from '@/utils/sensors';

var template = function template(data) {
  return "\n<div class=\"bottom-button-group\">\n  <div class=\"bottom-button-group__btn bottom-button-group__btn--pay btn_actived\" data-type=\"pay\">\n    <span class=\"bottom-button-group__btn-text\">".concat(data.payBtnText, "</span>\n  </div>\n  <div class=\"bottom-button-group__btn bottom-button-group__btn--free btn_actived\" data-type=\"free\">\n    <span class=\"bottom-button-group__btn-text\">").concat(data.freeBtnText, "</span>\n  </div>\n</div>\n");
};

var BottomButtonGroup = function () {
  function BottomButtonGroup() {
    this.$container = null;
    this.data = null;
  }

  BottomButtonGroup.prototype.render = function (data) {
    return template(data);
  };

  BottomButtonGroup.prototype.mount = function (container, data) {
    this.$container = container;
    this.data = data;
    var $payBtn = container.querySelector('.bottom-button-group__btn--pay');
    var $freeBtn = container.querySelector('.bottom-button-group__btn--free'); // 按钮组曝光埋点

    sensElementView({
      c_element_name: '底部双按钮曝光',
      activity_label: '投放',
      activity_id: data.campaignId,
      material_ids: ["".concat(data.campaignPageId)]
    }); // 点击一元购按钮 → 通过 bus 通知 CourseSelection，设置一元购意图

    $payBtn === null || $payBtn === void 0 ? void 0 : $payBtn.addEventListener('click', function () {
      sensClickInitiative({
        $element_name: '投放落地页_购课按钮',
        activity_label: '投放',
        activity_id: data.campaignId,
        material_ids: ["".concat(data.campaignPageId)],
        $element_type: '页面'
      }); // 通知 CourseSelection 用户意图为一元购，然后拉起选年级弹窗

      bus.emit('ChooseCoursePayIntent');
    }); // 点击免费解锁按钮 → 通过 bus 通知 CourseSelection，设置免费解锁意图

    $freeBtn === null || $freeBtn === void 0 ? void 0 : $freeBtn.addEventListener('click', function () {
      sensClickInitiative({
        $element_name: '投放落地页_加老师免费领按钮',
        activity_label: '投放',
        activity_id: data.campaignId,
        material_ids: ["".concat(data.campaignPageId)],
        $element_type: '页面'
      }); // 通知 CourseSelection 用户意图为免费解锁，然后拉起选年级弹窗

      bus.emit('ChooseCourseFreeIntent');
    });
  };

  return BottomButtonGroup;
}();

export default BottomButtonGroup;